<template>
  <div class="travelagencylist">
    <!-- 返回导航栏 -->
    <div class="wrapper-box">
      <div class="ranking-tab-wrap">
        <tab :tabList="rankingTab"
             :name="'rankingTab'"
             @onSwitch="myPending"
             ref="tabchild"
             :tabFontSize="'14px'"></tab>
      </div>
      <div class="search-box">
        <div class="input-box">
          <img src="../../assets/travelAgency/ic_search.png"
               alt
               class="search-icon" />
          <input style
                 type="text"
                 placeholder="搜索旅行社名称或者统一社会信用代码"
                 class="search-input"
                 v-model="inputValue" />
        </div>
        <div class="search-btn"
             @click="goSearchPage">搜索</div>
      </div>
      <div class="choose-box">
        <div class="left-title">
          <div class="titles"
                v-if="currentIndex == 0"
            @click="showTypePicker1 = true"
        >{{checkoutValue}}</div>
          <div class="down">
              <img
                  v-if="currentIndex == 0"
                  src="../../assets/travelAgency/ic_jiantou_down.png"
                  alt
                  class="down-icon"
              />
          </div>
          <div class="titles"
               v-if="currentIndex == 2"
               style="font-size:4.27vw;">黑名单监管旅行社</div>
          <div class="titles"
               v-if="currentIndex == 1"
               style="font-size:4.8vw;">重点关注旅行社</div>
        </div>
        <div class="numbers">{{totalNumber}} 家</div>
      </div>
      <van-list v-if="cityColumns.length > 0"
                ref="vanList"
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                @load="loadMore"
                class="wrapper">
        <div class="lists-box">
          <div class="right-con line_bottom">
            <!-- <div class="city-box"
                @click="originCityId == '34' ? showCityPicker = true : ''"
                > -->
                <div class="city-box"
                @click="showCityPicker = true"
                >
              <p class="texts">{{cityText}}</p>
              <img src="../../assets/travelAgency/ic_jiantou_down1.png"
                  alt
                  class="down-icon"
                  />
            </div>
            <div class="city-box type-box"
                @click="showType">
              <p class="texts">{{typeText}}</p>
              <img src="../../assets/travelAgency/ic_jiantou_down1.png"
                  alt
                  class="down-icon" />
            </div>
          </div>
          <div v-for="(items,index) in listData"
               :key="index"
               @click="toDetail(items)">
            <div class="items-box">
              <div class="agency-img"
                   :style="'background-image:url(' + items.photoPath + ');'"
                   v-if="items.photoPath">
                <!-- <img :src="items.photoPath" alt class="agency-img" v-if="items.photoPath" />
              <img src="../../assets/travelAgency/ic_Bitmap.png" alt class="agency-img" v-else/> -->
                <p class="wait" v-if="items.state==1"><span>待审核</span></p>
              </div>
              <div class="agency-img"
                   v-else
                   :style="'border: 0'"></div>
              <div class="info-box">
                <div class="company-name">{{items.name}}</div>
                <div class="tag-box">
                  <smllabel class="tag"
                            v-if="isParentList[items.isParent-1]"
                            :bgColor="'#fff'"
                            :borderColor="'#36B374'"
                            :txtColor="'#36B374'">{{isParentList[items.isParent-1]}}</smllabel>
                  <smllabel class="tag"
                            v-if="!items.area"
                            :bgColor="'#fff'"
                            :borderColor="'#36B374'"
                            :txtColor="'#36B374'">其他地区</smllabel>
                  <smllabel class="tag"
                            v-for="(areaItem,idx) in cityAllList"
                            :key="idx"
                            :bgColor="'#fff'"
                            :borderColor="'#36B374'"
                            :txtColor="'#36B374'"
                            v-show="items.area && areaItem.VALUE == items.area">{{areaItem.short_name}}&nbsp;{{areaItem.content}}</smllabel>
                </div>
                <div class="tag-box">
                  <smllabel :bgColor="'#FF8C19'"
                            :borderColor="'#FF8C19'"
                            :txtColor="'#fff'"
                            v-if="items.isSupervise != 0">重点关注中</smllabel>
                  <smllabel :bgColor="'#FF4D4D'"
                            :borderColor="'#FF4D4D'"
                            :txtColor="'#fff'"
                            v-if="items.isBlacklist != 0">黑名单</smllabel>
                </div>
                <div class="prices-box">
                  <!-- <div class="tags" v-if="items.integrityScore">诚信指数 {{items.integrityScore}}分</div>
                <div class="tags" v-if="items.pointsDeducted">扣分 {{items.pointsDeducted}}次</div>
                <div class="tags" v-if="items.complaintTime">投诉 {{items.complaintTime}}次</div> -->
                </div>
              </div>
            </div>
            <rline v-if="index < listData.length - 1"></rline>
          </div>

        </div>
      </van-list>
      <empty :type="3"
             v-if="listData.length <= 0 && !loading"></empty>
    </div>
    <!-- 城市弹窗 -->
    <van-popup v-model="showCityPicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="cityColumns"
                  @cancel="showCityPicker = false"
                  @confirm="getCityValue"
                  value-key="content"
                  :default-index="Number(cityIndex)"
                  />
    </van-popup>
    <!-- 类型弹窗 -->
    <van-popup v-model="showTypePicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="typeColumns"
                  @cancel="showTypePicker = false"
                  @confirm="getTypeValue"
                  value-key="content" />
    </van-popup>
    <van-popup v-model="showTypePicker1" position="bottom">
          <van-picker
              show-toolbar
              :columns="typeColumns1"
              @cancel="showTypePicker1 = false"
              @confirm="onTypeConfirm"
          />
      </van-popup>
  </div>
</template>
<script>
    import tab from './components/tab';
    import api from '../../service/modules/travel';
    import rline from './components/line'
    import smllabel from './components/small-label'
    import empty from 'comps/empty';
    import util from '@/utils/common';
    export default {
        components: {
            tab,
            rline,
            empty,
            smllabel
        },
        data () {
            return {
                currentIndex: 0,
                cols1: 1,
                cols2: 1,
                rankingTab: ['全部', '重点关注', '黑名单监管'],
                showPicker: false,
                cityColumns: [],
                typeColumns: [
                    {
                        content: '全部类型',
                        value: ''
                    },
                    {
                        content: '总社',
                        value: 1
                    },
                    {
                        content: '分社',
                        value: 2
                    },
                    {
                        content: '网点',
                        value: 3
                    }
                ],
                listData: [],
                pagination: { total: 0, current_page: 0, page_size: 0 },
                loading: false,
                finished: false,
                finishedText: '',
                cityList: [],
                city: '34',
                cityText: '全部城市',
                isParent: '',
                typeText: '类型',
                type: '',
                inputValue: '',
                totalNumber: '',
                isLoadOver: false,
                cityAllList: [],
                originCityId: '',
                cityIndex: 0,
                showCityPicker: false,
                showTypePicker: false,
                isParentList: ['总社', '分社', '网点'],
                showTypePicker1: false,
                typeColumns1: ['全部旅行社', '待审核', '已审核'],
                state: null,
                checkoutValue: '旅行社',
                defaultState: null
            };
        },
        computed: {
        },
        watch: {
        },
        methods: {
            // 全部旅行社筛选
            onTypeConfirm (value) {
                this.showTypePicker1 = false;
                this.checkoutValue = value;
                if (value === '全部旅行社' && this.currentIndex === 0) {
                    this.state = null;
                } else if (value === '待审核' && this.currentIndex === 0) {
                    this.state = 1;
                } else if (value === '已审核' && this.currentIndex === 0) {
                    this.state = 3;
                } else {
                    this.state = null;
                }
                this.listData = [];
                this.getDataByPage();
            },
            // 字符串补逗号
            formatNum (str) {
                var newStr = '';
                var count = 0;
                for (var i = str.length - 1; i >= 0; i--) {
                    if (count % 3 === 0 && count !== 0) {
                        newStr = str.charAt(i) + ',' + newStr;
                    } else {
                        newStr = str.charAt(i) + newStr;
                    }
                    count++;
                }
                str = newStr; // 自动补小数点后两位
                return str;
            },
            // 跳转搜索页面
            goSearchPage () {
                if (this.inputValue) {
                    this.inputValue = this.inputValue.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
                    this.$router.push({ path: '/travelAgency/search', query: { key: this.inputValue } })
                } else {
                    console.log('搜索框不能为空')
                }
            },
            // 标签切换
            myPending (index) {
                if (index === 0) {
                    this.type = ''
                    this.checkoutValue = '旅行社'
                    this.state = null
                } else if (index === 1) {
                    this.type = 'supervise'
                } else if (index === 2) {
                    this.type = 'blacklist'
                }
                if (this.isLoadOver) {
                    this.currentIndex = index;
                    localStorage.travelTabHomeCurrentIndex = index
                    this.pagination = { total: 0, current_page: 0, page_size: 0 };
                    this.listData = [];
                    this.loading = true;
                    this.finished = false
                    this.getDataByPage();
                }
            },
            // 获取所有的市
            getAllCity () {
                api.getCity({ city: null }).then(res => {
                    let city = [{ value: '34', content: '全部地区' }]
                    this.cityColumns = [...city, ...res.data.list]
                });
            },
            showType () {
                this.showTypePicker = true
            },
            // 城市选值
            getCityValue (value) {
                this.city = value.value;
                this.cityText = value.content
                this.pagination = { total: 0, current_page: 0, page_size: 0 };
                this.listData = [];
                this.loading = true;
                this.finished = false
                this.showCityPicker = false
                this.getDataByPage();
            },
            // 类型选值
            getTypeValue (value) {
                this.isParent = value.value
                this.typeText = value.content
                this.pagination = { total: 0, current_page: 0, page_size: 0 };
                this.listData = [];
                this.loading = true;
                this.finished = false
                this.showTypePicker = false
                this.getDataByPage();
            },
            // 根据页数获取数据
            getDataByPage () {
                api
                    .travelList({
                        p: parseInt(this.pagination.current_page) + 1,
                        pageSize: 20,
                        city: this.city,
                        type: this.type,
                        travelStatus: this.type?'':'1',
                        isParent: this.isParent,
                        state: this.state == null ? this.defaultState : this.state
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.listData = [...this.listData, ...res.data.list];
                            this.pagination = res.data.pagination;
                            this.totalNumber = this.formatNum(String(this.pagination.total))
                            this.loading = false;
                            this.isLoadOver = true
                            if (this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)) {
                                this.finished = true;
                            }
                        }
                    });
            },
            // 拉取更多数据
            loadMore () {
                this.getDataByPage();
            },
            // 跳转详情页
            toDetail (items) {
                // 存储历史记录

                // console.log(localStorage.travelHistoryList)
                // return;
                if (localStorage.travelHistoryList) {
                    let travelHistoryList = JSON.parse(localStorage.travelHistoryList)
                    let isExit = false
                    travelHistoryList.map((lists, index) => {
                        if (items.id === lists.id) {
                            isExit = true
                        }
                    })
                    if (!isExit) {
                        if (travelHistoryList.length >= 10) {
                            let newArr = travelHistoryList.filter((val, index, arr) => {
                                return index !== 0;
                            })
                            newArr.push(items)
                            localStorage.travelHistoryList = JSON.stringify(newArr)
                            setTimeout(() => {
                                this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                            }, 300)
                        } else {
                            travelHistoryList.push(items)
                            localStorage.travelHistoryList = JSON.stringify(travelHistoryList)
                            setTimeout(() => {
                                this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                            }, 300)
                        }
                    } else {
                        this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                    }
                } else {
                    let travelHistoryList = []
                    travelHistoryList.push(items)
                    localStorage.travelHistoryList = JSON.stringify(travelHistoryList)
                    setTimeout(() => {
                        this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                    }, 300)
                }
                // util.setJsonLocal('travelHistoryList',items);
                // setTimeout(() => {
                //     this.$router.push({ path: '/travelAgency/info', query: { id: items.id } })
                // }, 300)
            },
            // 拉取所有市和县的数据
            getTravelCityAll () {
                api.getTravelCityAll().then(res => {
                    if (res.ret === 0) {
                        this.cityAllList = res.data.list
                    }
                })
            }
        },
        mounted () {
            let index = localStorage.travelTabHomeCurrentIndex ? parseInt(localStorage.travelTabHomeCurrentIndex) : '';
            if (!index) {
              index = this.$route.query.index ? Number(this.$route.query.index) : 0
            }
            if (index === 1) {
                this.type = 'supervise'
            } else if (index === 2) {
                this.type = 'blacklist'
            }
            this.currentIndex = index;
            this.city = this.$route.query.cityId ? this.$route.query.cityId : '34'
            this.cityText = this.$route.query.cityText
            this.defaultState = this.$route.query.defaultState ? this.$route.query.defaultState : null
            this.originCityId = localStorage.originCityId || ''
            this.$refs.tabchild.switchTab(this.currentIndex);
            this.getAllCity();
            this.getTravelCityAll()
            localStorage.removeItem('travelHistoryList')
        },
        created () { }
    };
</script>
<style scoped lang="less">
@vv: 3.75vw;
.travelagencylist {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);

  .wrapper-box {
    box-sizing: border-box;
    padding: 0 12 / @vv;
    padding-top: 60 / @vv;
    overflow: hidden;
    .ranking-tab-wrap {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 9;
      background: rgba(251, 251, 251, 1);
      box-sizing: border-box;
      padding-left: 12 / @vv;
      .data-card-tab {
        margin-bottom: 24 / @vv;
      }
    }
    .search-box {
      height: 28 / @vv;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12 / @vv;
      .input-box {
        flex: 1;
        margin-right: 12 / @vv;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 16 / @vv;
        background: rgba(245, 245, 245, 1);
        border-radius: 1 / @vv;
        .search-icon {
          width: 15 / @vv;
          margin-right: 8 / @vv;
        }
        input::-webkit-input-placeholder {
          font-size: 12 / @vv;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17 / @vv;
        }

        .search-input {
          flex: 1;
          background: rgba(245, 245, 245, 1);
        }
      }
      .search-btn {
        width: 40 / @vv;
        height: 28 / @vv;
        background: rgba(245, 245, 245, 1);
        border-radius: 1 / @vv;
        font-size: 12 / @vv;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);
        line-height: 28 / @vv;
        text-align: center;
      }
    }
    .choose-box {
      height: 44 / @vv;
      display: flex;
      align-items: center;
      justify-content:space-between;
      .left-title {
        height: 20 / @vv;
        display: flex;
        align-items: flex-end;

        .titles {
          font-size: 20 / @vv;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 700;
          color: rgba(51, 51, 51, 1);
          line-height: 20 / @vv;
        }
        .numbers {
          font-size: 12 / @vv;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 14 / @vv;
          margin-bottom: -5px;
        }
      }
      .down {
          display: flex;
          height: 100%;
          align-items: center;
          margin-left: 4px;
          img {
              width: 6px;
              height: 4px;
              margin-top: 5px;
          }
      }
    }
    .lists-box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 / @vv 0 / @vv 10 / @vv 0 / @vv rgba(0, 0, 0, 0.04);
      border-radius: 3 / @vv;
      .right-con {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        .city-box {
          display: flex;
          align-items: center;
          height: 44 / @vv;
          margin-left: 16 / @vv;

          .texts {
            font-size: 12 / @vv;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 44 / @vv;
            margin-right: 5 / @vv;
          }
          .down-icon {
            width: 6 / @vv;
            height: 4 / @vv;
          }
        }
      }
      .items-box {
        display: flex;
        box-sizing: border-box;
        padding: 16 / @vv 0 / @vv 16 / @vv 16 / @vv;
        position: relative;

        .agency-img {
          width: 84 / @vv;
          height: 84 / @vv;
          margin-right: 12 / @vv;
          // object-fit: cover;
          background: url(../../assets/travelAgency/ic_Bitmap.png);
          border-radius: 3 / @vv;
          border: 1 / @vv solid rgba(238, 238, 238, 1);
          background-size: auto 100%;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
          box-sizing: border-box;
          .wait {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 18px;
            background-color: #36b374;
            text-align: center;
            line-height: 18px;
            color: #fff;
            border-radius: 0 0 3 / @vv 3 / @vv;
            font-size: 0;
            span {
              display: inline-block;
              font-size: 11px;
              transform: scale(0.9);
              margin-top: 1px;
            }
          }
        }

        .info-box {
          height: 100%;
          flex: 1;
          // overflow: hidden;

          .company-name {
            font-size: 14 / @vv;
            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            line-height: 20 / @vv;
          }

          .tag-box {
            // width: 300/@vv;
            height: 18 / @vv;
            display: flex;
            align-items: center;
            // flex-wrap: wrap;
            margin: 6 / @vv 0;
            // transform: scale(0.5);
            // transform-origin: left 0;
          }
          .prices-box {
            min-height: 14 / @vv;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin-top: -17/@vv;

            .tags {
              font-size: 10 / @vv;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 14 / @vv;
              box-sizing: border-box;
              padding-left: 7 / @vv;
              padding-right: 8 / @vv;
              border-right: 1 / @vv solid #979797;
              // margin-right: 7/@vv;

              &:first-child {
                padding-left: 0;
              }

              &:last-child {
                border-right: none;
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
